@if (!localeSelected) {
  <header>{{ placeholder }}</header>
}
@if (localeSelected && !languagesOnlyOfCountry) {
  <header
    [attr.title]="localeMappings.countries[localeSelected.country] + (localeSelected.language ? ' (' + localeMappings.languages[localeSelected.language] + ')' : '')"
    >
    {{ localeMappings.countries[localeSelected.country] }}
    @if (localeSelected.language) {
      <span>({{ localeMappings.languages[localeSelected.language] }})</span>
    }
  </header>
}
@if (localeSelected && languagesOnlyOfCountry) {
  <header [attr.title]="localeMappings.languages[localeSelected.language]">
    {{ localeMappings.languages[localeSelected.language] }}
  </header>
}
<aside [attr.title]="placeholder">▼</aside>
@if (active) {
  <main [style.width]="width + 'px'">
    @for (locale of localeOptions; track locale) {
      <div
        [style.fontWeight]="locale.language ? 'normal' : 'bold'"
        [style.paddingLeft]="locale.language ? '40px' : '20px'"
        (click)="handleSelected(locale)"
        >
        {{ localeMappings.languages[locale.language] || localeMappings.countries[locale.country] }}
      </div>
    }
  </main>
}
